import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WifiLandingPageComponent } from './wifi-landing-page/wifi-landing-page.component';
import { WifiLinkComponent } from './wifi-link/wifi-link.component';

const routes: Routes = [
  {
    path: '', component: WifiLinkComponent,
    children: [
      {
        path: 'merakiDashboard', component: WifiLandingPageComponent,
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WifiRoutingModule { }
